var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenuHideLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 10L11.8536 12.2684C12.0488 12.4358 12.0488 12.7071 11.8536 12.8745C11.6583 13.0418 11.3417 13.0418 11.1464 12.8745L8.14645 10.303C7.95118 10.1357 7.95118 9.86432 8.14645 9.69695L11.1464 7.12553C11.3417 6.95816 11.6583 6.95816 11.8536 7.12553C12.0488 7.29289 12.0488 7.56425 11.8536 7.73162L9.20711 10Z",
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_109_1797",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 4,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 10L11.8536 12.2684C12.0488 12.4358 12.0488 12.7071 11.8536 12.8745C11.6583 13.0418 11.3417 13.0418 11.1464 12.8745L8.14645 10.303C7.95118 10.1357 7.95118 9.86432 8.14645 9.69695L11.1464 7.12553C11.3417 6.95816 11.6583 6.95816 11.8536 7.12553C12.0488 7.29289 12.0488 7.56425 11.8536 7.73162L9.20711 10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_109_1797)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.37114e-07 10C-6.78525e-07 4.47715 4.47715 6.78525e-07 10 4.37114e-07C15.5228 1.95703e-07 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 -1.95703e-07 15.5228 -4.37114e-07 10Z",
    fill: "#0076FF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuHideLight);
export default __webpack_public_path__ + "static/media/ico-menu-hide-light.9258db3a80164619226bc37e185bb51b.svg";
export { ForwardRef as ReactComponent };